<template>
  <div class="home-page">
    <!--    <header-component></header-component>-->
    <br/>
    <div class="search-jod">
      <el-input placeholder="搜索职位、公司" v-model="searchKeyWord" class="input-with-select" @keyup.enter.native="searchCompanyAndJob">
        <!--<el-select v-model="select" slot="prepend" placeholder="请选择">
          <el-option label="餐厅名" value="1"></el-option>
          <el-option label="订单号" value="2"></el-option>
          <el-option label="用户电话" value="3"></el-option>
        </el-select>-->
        <el-button slot="append" icon="el-icon-search" @click="searchCompanyAndJob"></el-button>
      </el-input>
      <div class="hot-job">
        <span class="hot-job-title">热门职位：</span>
        <span class="hot-job-item" @click="goPage('JobWanted', {name: item})" v-for="(item, index) of hotJobs" :key="index">{{item}}</span>
      </div>
    </div>

    <div class="home-content">
      <div style="height: calc(100vh - 420px)">
        <div class="job-menu">
          <div v-for="(item, index) of jobMenu" :key="index" @mouseover="showMenuDetail(item)"
               @mouseout="hideMenuDetail()">
            <div class="job-menu-item" v-if="item.children && item.children.length > 0">
              <span class="job-menu-item-title">{{item['dictName']}}</span>
              <span class="el-icon-arrow-right"></span>
            </div>
          </div>
        </div>

        <!--      各个大类的职业细分显示-->
        <div class="items-of-one-type" v-if="!!jobMenuDetails" @mouseover="isOnJobMenu = true"
             @mouseout="moveOutJobMenuDetail()">
          <div class="detail-card-title">{{jobMenuDetails['dictName']}}</div>
          <div class="detail-card-item" v-for="(item, index) of jobMenuDetails['children']" :key="index">
            <div v-if="item['children'] && item['children'].length > 0">
              <div class="detail-item-title">{{item['dictName']}}</div>
              <div class="detail-item-values">
              <span class="detail-item-values-name" v-for="(oneItem, itemIndex) of item['children']"
                    :key="itemIndex" @click="goPage('JobWanted', oneItem)">{{oneItem['dictName']}}</span>
              </div>
            </div>
          </div>
        </div>

        <!--      广告招租位或其他&#45;&#45;&#45;&#45;&#45;&#45;轮播图-->
        <div class="running-img-area">
          <el-carousel height="500px">
            <el-carousel-item v-for="(item, index) in advertisementArr" :key="index">
              <img :src="item.picUrl" :title="item.advertisementName"/>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="right-notice">
          <div style="padding: 10px 10px 0 10px; height: calc(100% - 170px)">
            <div class="seen-jobs-title">看过的职位</div>
            <div class="seen-jobs-item" v-for="(item, index) of seenJobs" :key="index" @click="goJobDetailPage(item)">
              <div class="seen-jobs-item-head">
                <span class="seen-jobs-item-name">{{item.positionName}}</span>
                <span class="seen-jobs-item-salary">{{item['salaryDict']['dictName']}}</span>
              </div>
              <div class="seen-jobs-item-company">{{item.companyName}}</div>
              <el-divider></el-divider>
            </div>

            <img v-if="seenJobs.length === 0" :src="iconUrl" style="width: 200px" />
            <div v-if="seenJobs.length === 0" style="color: #666666">暂无数据</div>
            <div v-if="seenJobs.length === 0" style="text-align: left;margin-top: 30px">
              暂无查看过的职位信息，想了解职位动态？想成为行业大牛？赶快去
              <span v-if="!$store.get('user')" style="color: #409eff;cursor: pointer" @click="goPage('Login')">登录</span>
              <span v-if="$store.get('user')" style="color: #409eff;cursor: pointer" @click="goPage('JobWanted')">求职页面</span>
              看看吧
            </div>
          </div>

          <div class="news">
            <div class="news-title">公告栏</div>
            <!--<swiper class="my-swipe" :options="swiperOption">
              <swiper-slide class="slide" v-for="(item, key) in news" :key="key">{{ item.content }}</swiper-slide>
            </swiper>-->
            <!--<el-carousel height="120px" direction="vertical">
              <el-carousel-item v-for="item in news" :key="item">
                <h3 class="medium">{{ item.content }}</h3>
              </el-carousel-item>
            </el-carousel>-->
            <div class="news-content-box">
              <ul class="news-content-ul" :class="{'news-content-ul-animate': animate}">
                <li v-for="(item, key) in news" :key="key" :title="item.titleShow">
                  <div>{{item.noticeContent + ' 发布于：'}}{{item.createDate | dateFormat('YYYY-MM-DD HH:mm:ss')}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!--      热招职位-->
      <div class="hot-jobs-category">
        <h2 class="hot-option-title">热招职位</h2>
        <div>
          <div class="card" v-for="(item, index) of hotJobCard" :key="index" @click="goJobDetailPage(item)">
            <el-card class="box-card">
              <div style="height: 100%;width: 60px;float: left">
                <div class="enterprise-name">
                  <el-avatar shape="square" :size="60" :src="item.icon"></el-avatar>
                </div>
              </div>

              <div class="job-info">
                <div class="job-info-name">{{item.positionName}}</div>
                <div class="job-info-req">
                  <span class="job-info-req-item" title="工作城市">{{item['positionCity'] || '--'}}</span>
                  <span class="job-info-req-item" title="工作经验要求">{{item['experienceDict']['dictName'] || '--'}}</span>
                  <span class="job-info-req-item" title="学历要求">{{item['academicDegreeDict']['dictName']}}</span>
                </div>
                <div class="job-info-salary" title="薪资待遇">{{item['salaryDict']['dictName'] || '--'}}</div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
      <!--      热门企业-->
      <!--<div class="hot-enterprises">
        <h2 class="hot-option-title">热门企业</h2>
      </div>-->
    </div>
  </div>
</template>

<script>
import {MessageBox} from 'element-ui'
import moment from 'moment'

export default {
  name: 'Home',
  data () {
    return {
      searchKeyWord: '',
      hotJobs: ['Java', 'PHP', 'C++', 'iOS', 'UI'],
      jobMenu: [],
      jobMenuDetails: null,
      isOnJobMenu: false,
      images: [
        require('../../assets/home_1.jpg'),
        require('../../assets/home_2.jpg'),
        require('../../assets/home_3.jpg'),
        require('../../assets/home_4.jpg')
      ],
      advertisementArr: [],
      locationOrigin: location.origin,
      hotJobCard: [],
      seenJobs: [],
      news: [],
      animate: false,
      iconUrl: require('../../assets/no_data.jpg')
    }
  },
  methods: {
    searchCompanyAndJob () {
      this.goPage('JobWanted', {name: this.searchKeyWord})
    },
    goPage (page, param) {
      if (param && param['dictName']) {
        this.$router.push({
          name: page,
          query: {
            key: param['dictName']
          }
        })
      } else {
        this.$router.push({
          name: page,
          params: null
        })
      }
    },
    showMenuDetail (item) {
      setTimeout(() => {
        this.jobMenuDetails = item
      }, 200)
    },
    hideMenuDetail () {
      setTimeout(() => {
        if (!this.isOnJobMenu) {
          this.jobMenuDetails = null
        }
      }, 200)
    },
    moveOutJobMenuDetail () {
      this.isOnJobMenu = false
      this.hideMenuDetail()
    },
    showAnimate: function () {
      this.animate = true
      setTimeout(() => {
        this.news.push(this.news[0])
        this.news.shift()
        this.animate = false
      }, 800)
    },
    goJobDetailPage (position) {
      if (!this.$store.get('user')) {
        return false
      }
      if (this.$store.get('user').roleName === 'enterprise') {
        MessageBox.alert('请退出登录后使用求职者角色的账号登录再进行求职！', '提示', {type: 'warning'})
        return false
      }
      let routeData = this.$router.resolve({
        path: `/job-detail`,
        query: {
          positionId: position.id
        }
      })
      window.open(routeData.href, '_blank')
    }
  },
  mounted () {
    if (location.origin.includes('192.168.3.15') || location.origin.includes('localhost')) {
      this.ID_CARD_URI = location.origin + '/api/recurit/document/upload/idCard?category=ADVERTISEMENT'
      // this.locationOrigin = 'http://134.175.126.154:8080'
      this.locationOrigin = 'http://www.rengeshenzheng.com.cn/'// todo
    }
    this.$http.get(this.$api.getPositionTypeTree.url, {dictNum: 'PROFESSION'}).then(_ => {
      if (_ && _.code === 200 && _.data && _.data[0].children) {
        this.jobMenu = _.data[0].children || []
        console.log(this.jobMenu)
      }
    })

    setInterval(this.showAnimate, 2000)

    if (this.$store.get('user')) {
      this.$http.get(this.$api.getRecentlyViewPositions.url, {
        userCode: this.$store.get('user').userCode
      }).then(_ => {
        if (_ && _.code === 200 && _.data) {
          this.seenJobs = _.data
        }
      })
    }

    this.$http.get(this.$api.getPopularPositions.url).then(_ => {
      if (_ && _.code === 200 && _.data) {
        this.hotJobCard = _.data
        this.hotJobCard.forEach(item => {
          item.icon = require('../../assets/logo.jpg')
        })
      }
    })

    this.$http.get(`${this.$api.getNotices.url}?pageNum=${1}&pageSize=${10}`).then(_ => {
      if (_ && _.code === 200 && _.data) {
        this.news = (_.data.list || []).map(item => {
          return Object.assign(item, {titleShow: `${item.noticeContent} 发布于：${moment(item.createDate).format('YYYY-MM-DD HH:mm:ss')}`})
        })
        console.log(this.news)
      }
    })

    this.$http.get(`${this.$api.getAdvertisements.url}?pageNum=${1}&pageSize=${4}`, {}).then(_ => {
      if (_ && _.code === 200) {
        this.advertisementArr = (_.data.list || []).map(item => {
          let picUrl = `${this.locationOrigin}/${item['advertisementImage']['url']}/${item['advertisementImage']['documentName']}.${item['advertisementImage']['suffix']}`
          return Object.assign(item, {picUrl})
        })
        console.log(this.advertisementArr);
      }
    })
  }
}
</script>

<style scoped>
  .home-page {
    text-align: center;
  }

  .search-jod {
    width: 800px;
    margin: auto;
  }

  .home-content {
    width: 1200px;
    margin: auto;
    position: relative;
  }

  .input-with-select /deep/ .el-input-group__append {
    border-color: #409EFF;
  }

  .input-with-select button {
    background: #409EFF;
    color: #fff;
    border-radius: 0;
    cursor: pointer;
  }

  .input-with-select:active {
    background: #ffffff;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    color: #409EFF;
  }

  .hot-job {
    text-align: left;
    margin: 10px 0 20px;
  }

  .hot-job-title {
    color: #999999;
  }

  .hot-job-item {
    color: #409EFF;
    cursor: pointer;
    margin-right: 30px;
  }

  .job-menu {
    width: 220px;
    height: 500px;
    display: inline-block;
    float: left;
    text-align: left;
    /*box-shadow: 1px 2px 10px rgba(0, 0, 0, .1);*/
    background: #ffffff;
  }

  .job-menu-item {
    padding: 8px 20px;
  }

  .job-menu-item:hover {
    color: #ffffff;
    background: #409EFF;
  }

  .items-of-one-type {
    box-shadow: 1px 2px 10px rgba(0, 0, 0, .1);
    width: 650px;
    position: absolute;
    left: 220px;
    text-align: left;
    padding: 20px;
    min-height: 400px;
    z-index: 999;
    background: #ffffff;
  }

  .running-img-area {
    display: inline-block;
    float: left;
    margin-left: 15px;
    width: calc(100% - 470px);
  }
  .right-notice {
    width: 220px;
    height: 500px;
    display: inline-block;
    float: left;
    margin-left: 15px;
    background: #ffffff;
  }
  .seen-jobs-title {
    font-size: 16px;
    color: #409eff;
    margin-bottom: 15px;
  }
  .seen-jobs-item {
    text-align: left;
    cursor: pointer;
  }
  .seen-jobs-item /deep/ .el-divider--horizontal {
    margin: 15px 0;
  }
  .seen-jobs-item-name {
    color: #414a60;
  }
  .seen-jobs-item:hover .seen-jobs-item-name {
    color: #409eff;
  }
  .seen-jobs-item-salary {
    float: right;
    color: #fc6c38;
  }
  .seen-jobs-item-company{
    margin-top: 5px;
    color: #8d92a1;
  }
  .news {
    height: 150px;
  }
  .news-title {
    padding: 5px 0;
    font-size: 16px;
    background: #fc6c38;
    color: #ffffff;
  }
  .news-content-box {
    position: relative;
    height: 100px;
    overflow: hidden;
    text-align: left;
    padding: 10px;
  }
  .news-content-ul {
    padding: 0;
    margin: 0;
    position: absolute;
    left: 10px;
    top: 10px;
  }
  .news-content-ul-animate {
    transition: all 0.8s;
    margin-top: -36px;
  }
  .news-content-ul li {
    list-style-type: none;
    line-height: 36px;
    height: 36px;
    background: #ffffff;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .news-content-ul li:hover {
    /*color: #409eff;*/
    /*text-decoration: underline;*/
  }

  .detail-card-title {
    font-weight: bolder;
  }

  .detail-card-item {
    /*padding: 10px 0;*/
  }

  .detail-item-title {
    display: inline-block;
    float: left;
    width: 100px;
    color: #999999;
    line-height: 24px;
    position: relative;
    top: 10px;
  }

  .detail-item-values {
    display: inline-block;
    color: #666666;
    width: calc(100% - 140px);
    padding: 10px 0;
    position: relative;
  }

  .detail-card-item:not(:last-child) .detail-item-values::before {
    position: absolute;
    content: '';
    width: 100%;
    border-top: 1px dashed #cccccc;
    bottom: 0;
  }

  .detail-item-values-name {
    display: inline-block;
    margin-right: 20px;
    cursor: pointer;
    line-height: 24px;
  }

  .detail-item-values-name:hover {
    color: #409EFF;
  }

  .hot-option-title {
    font-weight: normal;
    color: #333333;
  }

  .card {
    width: calc(33.3333333% - 10px);
    display: inline-block;
    text-align: left;
    height: 130px;
    margin-left: 15px;
    margin-bottom: 15px;
    cursor: pointer;
  }

  .card:nth-child(3n+1) {
    margin-left: 0;
  }

  .enterprise-name {
    display: inline-block;
    width: 60px;
    height: 60px;
    border: 1px solid #e9eef3;
    text-align: center;
    line-height: 58px;
    margin-top: 30px;
  }

  .job-info {
    max-width: 280px;
    padding-left: 10px;
    padding-top: 28px;
    float: left;
    width: calc(100% - 70px);
  }

  /deep/ .el-card__body {
    padding: 0 20px;
    height: 130px;
  }

  .job-info-name, .job-info-req, .job-info-salary {
    line-height: 24px;
  }

  .job-info-name {
    margin-left: 10px;
    font-size: 16px;
  }

  .job-info-salary {
    margin-left: 10px;
    color: #fd5f39;
    font-size: 16px;
  }

  .job-info-req-item {
    margin: 0 10px;
    position: relative;
  }

  .job-info-req-item:nth-child(2):before, .job-info-req-item:nth-child(3):before {
    position: absolute;
    content: '';
    border-left: 1px solid #cccccc;
    height: 100%;
    top: 0;
    left: -11px;
  }

  .job-info div {
    padding-bottom: 2px;
    white-space: nowrap;
  }

  .el-icon-arrow-right {
    float: right;
    font-size: 16px;
    color: #cccccc;
  }

  /deep/ .el-carousel__item img {
    object-fit: fill;
    width: 800px;
    height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue